<script setup>
import { keycloak } from "@/plugins/keycloak";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

keycloak
    .init({
        onLoad: "login-required",
        checkLoginIframe: false,
        useNonce: import.meta.env.PROD,
        responseMode: "fragment", // config query if dev on codespaces else fragment
        //unil test redirectUri: 'https://test-hec.unil.ch/signin?redirectTo=/consultation',
    })
    .then(authenticated => {
        if (authenticated) {
            let path = "/";
            if (route.query && route.query.redirectTo) {
                path = route.query.redirectTo;
            }
            router.push(path);
        }
    })
    .catch(() => {
        router.push("/error/TOKEN ERROR");
    });
</script>
<template>
    <div></div>
</template>
